const US_PHONE_NUMBER_LENGTH = 10;

/**
 * Formats a phone number to XXX-XXX-XXXX format
 * @param phoneNumber - Phone number in any format (e.g., "(718) 270-3015", "7182703015")
 * @returns Formatted phone number in XXX-XXX-XXXX format (e.g., "718-270-3015")
 */
export const formatPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) return '';

  const digitsOnly = phoneNumber.replace(/\D/g, '');

  if (digitsOnly.length === US_PHONE_NUMBER_LENGTH) {
    return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
  }

  return digitsOnly;
};
